import React from "react";

const Profile = () =>  {
        return (
            <h1>I am Profile page</h1>
        );
}

export default Profile;